import { useEffect, useState } from 'react'
import { Alert, Spinner } from 'react-bootstrap'
import { useParams } from 'react-router-dom'

import PaginaPublica from '../../components/Auth/PaginaPublica'
import api from '../../services/api'

/**
 * Un documento legal vigente: `/legal/aviso_privacidad`, `/legal/terminos`,
 * `/legal/condiciones_uso`. El registro los abre en otra pestaña.
 *
 * El contenido se escribe en Markdown desde el Admin y aquí se muestra **como texto**, con sus
 * saltos de línea: no hay librería de Markdown en el proyecto y meter HTML de la base en la
 * página abriría una puerta que un texto legal no necesita.
 */
export default function Legal() {
  const { tipo } = useParams()
  const [doc, setDoc] = useState(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    let vivo = true
    api.get(`/auth/legales/${tipo}/`)
      .then((r) => vivo && setDoc(r.data))
      .catch(() => vivo && setError(true))
    return () => {
      vivo = false
    }
  }, [tipo])

  let cuerpo
  if (error) {
    cuerpo = <Alert variant="secondary">Este documento no está disponible.</Alert>
  } else if (!doc) {
    cuerpo = <div className="text-center py-4"><Spinner animation="border" /></div>
  } else {
    cuerpo = (
      <>
        <p className="small text-muted">Versión {doc.version}</p>
        <div data-testid="legal-contenido" style={{ whiteSpace: 'pre-wrap', lineHeight: 1.55 }}>
          {doc.contenido}
        </div>
      </>
    )
  }

  return (
    <PaginaPublica titulo={doc?.titulo || 'Documentos legales'} encabezado={doc?.titulo || ''}
                   ancho="720px">
      {cuerpo}
    </PaginaPublica>
  )
}
